// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import HomePage from './pages/HomePage';
// import SignInPage from './pages/SigninPage';
// import SignupPage from './pages/SignupPage';
// import CostcoStoreView from './pages/CostcoStoreView';
// import DisplayProduct from './pages/DisplayProduct';
// import Checkout from './pages/Checkout';
// import ProductsPage from './pages/ProductsPage';
// import ProtectedRoute from './components/ProtectedRoute'; // Ise import zaroor karein

// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* --- 1. PUBLIC ROUTES (Har koi dekh sakta hai) --- */}
//         <Route path="/" element={<HomePage />} />
//         <Route path="/signin" element={<SignInPage />} />
//         <Route path="/signup" element={<SignupPage />} />
        
//         {/* Categories aur Products public rakhein taake log browse kar sakein */}
//         <Route path="/department/:id" element={<CostcoStoreView />} />
//         <Route path="/productswhole/:id" element={<ProductsPage />} />
//         <Route path="/product/:id" element={<DisplayProduct />} />

//         {/* --- 2. SECURE ROUTES (Sirf Login ke baad) --- */}
//         {/* Checkout par jaate hi user se login manga jayega */}
//         <Route 
//           path="/checkout" 
//           element={
//             <ProtectedRoute>
//               <Checkout />
//             </ProtectedRoute>
//           } 
//         />

//         {/* Future mein agar Profile page banayein toh wo bhi yahan aayega:
//         <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} /> 
//         */}

//         {/* --- 3. 404 PAGE (Optional) --- */}
//         <Route path="*" element={<Navigate to="/" replace />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;
// ✅ Match the actual component name





// import React, { useState, useEffect } from 'react';
// import { 
//   Phone, 
//   CheckCircle, 
//   Menu, 
//   X, 
//   ChevronDown, 
//   Facebook, 
//   Instagram, 
//   Linkedin 
// } from 'lucide-react';
// import logo from './assets/mqoelogo.png';
// import tajfront from './assets/tajweedfront.png';
// // Animation library for smooth effects
// import { motion, AnimatePresence } from 'framer-motion';

// const App = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isServicesOpen, setIsServicesOpen] = useState(false);
  
//   // Exact Color Palette from your requirement
//   const BRAND_GREEN = '#28a745'; 
//   const DARK_GREEN = '#147a44';  
//   const BG_CREAM = '#fdf8e1';    
//   const COFFEE_BROWN = '#5d4a3e';

//   // Fonts & Icons loading
//   useEffect(() => {
//     const link = document.createElement('link');
//     link.href = 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&family=Montserrat:wght@400;500;600;700&family=Inter:wght@300;400;600;700;800&display=swap';
//     link.rel = 'stylesheet';
//     document.head.appendChild(link);

//     const fontAwesome = document.createElement('link');
//     fontAwesome.rel = 'stylesheet';
//     fontAwesome.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
//     document.head.appendChild(fontAwesome);
//   }, []);

//   const serviceOptions = [
//     { name: "Noorani Qaida", link: "#services" },
//     { name: "Tajweed-e-Quran", link: "#services" },
//     { name: "Basic Islamic Educations", link: "#services" }
//   ];

//   // Animation Variants
//   const fadeInUp = {
//     hidden: { opacity: 0, y: 30 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
//   };

//   const staggerContainer = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.2
//       }
//     }
//   };

//   return (
//     <div className="min-h-screen text-[#333] overflow-x-hidden" style={{ backgroundColor: BG_CREAM, fontFamily: "'Inter', sans-serif" }}>
//       <style>{`
//         :root {
//             --primary-green: ${BRAND_GREEN};
//             --dark-green: ${DARK_GREEN};
//             --coffee: ${COFFEE_BROWN};
//         }

//         .nav-link {
//             font-weight: 600;
//             color: #1a3a2a;
//             transition: all 0.3s;
//             display: flex;
//             align-items: center;
//             gap: 4px;
//             cursor: pointer;
//             position: relative;
//         }

//         .nav-link::after {
//             content: '';
//             position: absolute;
//             bottom: -4px;
//             left: 0;
//             width: 0;
//             height: 2px;
//             background: var(--primary-green);
//             transition: width 0.3s;
//         }

//         .nav-link:hover::after {
//             width: 100%;
//         }

//         .dropdown-menu {
//             position: absolute;
//             top: 100%;
//             left: 0;
//             background: white;
//             min-width: 240px;
//             box-shadow: 0 15px 40px rgba(0,0,0,0.12);
//             border-radius: 12px;
//             padding: 12px 0;
//             opacity: 0;
//             visibility: hidden;
//             transform: translateY(15px);
//             transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
//             border-top: 4px solid var(--primary-green);
//             z-index: 50;
//         }

//         .group:hover .dropdown-menu {
//             opacity: 1;
//             visibility: visible;
//             transform: translateY(0);
//         }

//         .glow-effect {
//             position: relative;
//         }

//         .glow-effect::before {
//             content: '';
//             position: absolute;
//             inset: -10px;
//             background: radial-gradient(circle, rgba(40, 167, 69, 0.15) 0%, transparent 70%);
//             border-radius: inherit;
//             z-index: -1;
//             opacity: 0;
//             transition: opacity 0.3s;
//         }

//         .glow-effect:hover::before {
//             opacity: 1;
//         }

//         .floating {
//             animation: float 4s ease-in-out infinite;
//         }

//         @keyframes float {
//             0% { transform: translateY(0px); }
//             50% { transform: translateY(-15px); }
//             100% { transform: translateY(0px); }
//         }

//         .whatsapp-pulse {
//             animation: pulse-green 2s infinite;
//         }

//         @keyframes pulse-green {
//             0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7); }
//             70% { box-shadow: 0 0 0 15px rgba(37, 211, 102, 0); }
//             100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0); }
//         }

//         ::-webkit-scrollbar {
//             width: 8px;
//         }
//         ::-webkit-scrollbar-track {
//             background: #f1f1f1;
//         }
//         ::-webkit-scrollbar-thumb {
//             background: var(--primary-green);
//             border-radius: 10px;
//         }
//       `}</style>

//       {/* WhatsApp Floating Icon */}
//       <a 
//         href="https://wa.me/923024954689" 
//         target="_blank" 
//         rel="noopener noreferrer"
//         className="fixed bottom-8 right-6 z-[1001] whatsapp-pulse bg-[#25D366] p-4 rounded-full shadow-2xl cursor-pointer hover:scale-110 transition-transform active:scale-95"
//       >
//         <svg viewBox="0 0 24 24" width="32" height="32" fill="white">
//           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.72.937 3.659 1.432 5.632 1.433h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//         </svg>
//       </a>

//       {/* Header */}
//       <header className="py-4 px-6 lg:px-24 bg-white/90 backdrop-blur-md fixed top-0 left-0 right-0 z-[1000] shadow-sm">
//         <div className="max-w-7xl mx-auto flex justify-between items-center">
//           <motion.div 
//             initial={{ opacity: 0, x: -20 }}
//             animate={{ opacity: 1, x: 0 }}
//             className="flex items-center gap-3"
//           >
//             <div className="flex items-center">
//               {/* Replace with your actual logo img when ready */}
//               <img 
//           src={logo} 
//           alt="Madina Quran Online Education" 
//           className="h-16 w-auto object-contain" // Height ko logo ke design ke mutabiq 12 ya 14 rakhein
//         />
//             </div>
//             <span className="text-xl font-extrabold text-[#147a44] hidden lg:block tracking-tight">
//               Madina Quran Online Education
//             </span>
//           </motion.div>
          
//           <nav className="hidden md:flex gap-10">
//             <a href="#" className="nav-link">Home</a>
            
//             <div className="relative group">
//               <div className="nav-link cursor-pointer">
//                 Services <i className="fas fa-chevron-down text-[10px] ml-1"></i>
//               </div>
//               <div className="dropdown-menu">
//                 {serviceOptions.map((option, idx) => (
//                   <a key={idx} href={option.link} className="block px-6 py-3 text-[15px] font-medium text-gray-700 hover:bg-green-50 hover:text-green-600 transition-colors">
//                     {option.name}
//                   </a>
//                 ))}
//               </div>
//             </div>

//             <a href="#contact" className="nav-link">Contact Us</a>
//           </nav>

//           <motion.div 
//             whileTap={{ scale: 0.9 }}
//             className="md:hidden text-2xl cursor-pointer text-green-700" 
//             onClick={() => setIsMenuOpen(!isMenuOpen)}
//           >
//             <i className={isMenuOpen ? "fas fa-times" : "fas fa-bars"}></i>
//           </motion.div>
//         </div>
//       </header>

//       {/* Mobile Nav */}
//       <AnimatePresence>
//         {isMenuOpen && (
//           <motion.div 
//             initial={{ opacity: 0, height: 0 }}
//             animate={{ opacity: 1, height: 'auto' }}
//             exit={{ opacity: 0, height: 0 }}
//             className="md:hidden fixed top-[72px] left-0 right-0 bg-white p-5 flex flex-col gap-4 shadow-2xl z-[999] border-t overflow-hidden"
//           >
//             <a href="#" className="nav-link py-3 border-b border-gray-100" onClick={() => setIsMenuOpen(false)}>Home</a>
//             <div className="border-b border-gray-100">
//               <div className="nav-link py-3 justify-between" onClick={() => setIsServicesOpen(!isServicesOpen)}>
//                 Services <i className={`fas fa-chevron-${isServicesOpen ? 'up' : 'down'} text-sm`}></i>
//               </div>
//               {isServicesOpen && (
//                 <motion.div 
//                   initial={{ opacity: 0 }} 
//                   animate={{ opacity: 1 }} 
//                   className="pl-4 pb-4 flex flex-col space-y-3 mt-2"
//                 >
//                   {serviceOptions.map((option, idx) => (
//                     <a key={idx} href={option.link} className="text-sm font-medium text-gray-600 hover:text-green-600" onClick={() => setIsMenuOpen(false)}>
//                       {option.name}
//                     </a>
//                   ))}
//                 </motion.div>
//               )}
//             </div>
//             <a href="#contact" className="nav-link py-3" onClick={() => setIsMenuOpen(false)}>Contact Us</a>
//           </motion.div>
//         )}
//       </AnimatePresence>

//       {/* Main Content Area */}
//       <main className="max-w-6xl mx-auto px-6 lg:px-12 pt-28 pb-12">
//         <motion.h1 
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           className="text-[40px] md:text-[52px] font-bold text-[#222] mb-12 text-center md:text-left" 
//           style={{ fontFamily: "'Libre Baskerville', serif" }}
//         >
//           Tajweed Quran
//         </motion.h1>

//         {/* Hero Section */}
//         <motion.div 
//           initial={{ opacity: 0, scale: 0.95 }}
//           animate={{ opacity: 1, scale: 1 }}
//           transition={{ duration: 0.8 }}
//           className="relative mb-24 rounded-3xl overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.15)] border-8 border-white group"
//         >
//           {/* Using a placeholder since local asset isn't available here, but structure is same */}
//           <div className="w-full h-[500px] bg-[#e0f2f1] overflow-hidden">
//              <img 
//                 src={tajfront}
//                 className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
//                 alt="Students Learning"
//               />
//           </div>
          
//           <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
          
//           <motion.div 
//             initial={{ y: 50, opacity: 0 }}
//             animate={{ y: 0, opacity: 1 }}
//             transition={{ delay: 0.5 }}
//             className="absolute inset-x-0 bottom-12 flex justify-center px-6"
//           >
//              <div 
//                className="text-white py-6 px-10 md:px-16 rounded-2xl text-center text-xl md:text-[34px] font-bold shadow-2xl backdrop-blur-md border border-white/20 floating"
//                style={{ backgroundColor: `${BRAND_GREEN}dd`, fontFamily: "'Montserrat', sans-serif" }}
//              >
//                Online Quran Teaching Tajweed
//              </div>
//           </motion.div>
//         </motion.div>

//         {/* Middle Heading */}
//         <motion.div 
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//           variants={fadeInUp}
//           className="text-center mb-20"
//         >
//           <h2 
//             className="text-3xl md:text-[40px] font-bold mb-8 leading-tight"
//             style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//           >
//             🌙 Tajweed Courses – Al Qirat Online Quran Academy
//           </h2>
//           <p className="text-[#555] text-xl leading-[1.8] max-w-4xl mx-auto font-medium opacity-90">
//             Reciting the Quran beautifully starts with correct pronunciation. Our Tajweed courses guide students in Pakistan and worldwide through live one-on-one lessons.
//           </p>
//         </motion.div>

//         {/* Info Grid */}
//         <motion.div 
//           variants={staggerContainer}
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//           className="grid md:grid-cols-2 gap-10 mb-10"
//         >
//           {/* Card 1 */}
//           <motion.div 
//             variants={fadeInUp}
//             className="bg-white p-10 pt-12 rounded-[2rem] shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-gray-100 glow-effect hover:shadow-green-100 hover:shadow-2xl transition-all duration-500"
//           >
//             <h3 
//               className="text-[26px] font-bold mb-6 flex items-center gap-3"
//               style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//             >
//               <i className="fas fa-lightbulb text-yellow-500"></i> Why Learn Tajweed Online?
//             </h3>
//             <div className="space-y-6 text-[#555] text-[16px] leading-[1.8] font-medium">
//               <p>Flexibility tops the list. Live anywhere in Pakistan and still access expert Tajweed teachers. No travel, no fixed hours. Sessions fit your calendar.</p>
//               <p>Personal attention drives results. One teacher, one student, means every mistake gets fixed instantly. Beginners start with basic makharij, advanced readers polish rules.</p>
//               <p>Interactive tools make learning stick. Teachers share screens to highlight rules, recordings let you replay tricky spots. Parents see results within months.</p>
//             </div>
//           </motion.div>

//           {/* Card 2 */}
//           <motion.div 
//             variants={fadeInUp}
//             className="bg-white p-10 pt-12 rounded-[2rem] shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-gray-100 glow-effect hover:shadow-green-100 hover:shadow-2xl transition-all duration-500"
//           >
//             <h3 
//               className="text-[26px] font-bold mb-6 flex items-center gap-3"
//               style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//             >
//               <i className="fas fa-book-open text-blue-500"></i> What is Tajweed?
//             </h3>
//             <p className="text-[#555] text-[16px] mb-8 leading-[1.8] font-medium">
//               Tajweed means beautifying recitation through rules. It covers articulation points, elongation, and nasal sounds. The Prophet Muhammad (PBUH) recited with perfect rhythm.
//             </p>
//             <ul className="space-y-5">
//               {[
//                 { t: 'Makharij', d: 'articulation points of letters' },
//                 { t: 'Harakat', d: 'short vowels Fatha, Kasra, Damma' },
//                 { t: 'Madd', d: 'elongation of sounds' },
//                 { t: 'Ghunnah', d: 'nasal hums for Noon & Meem' },
//                 { t: 'Qalqalah', d: 'bouncing of stopped letters' },
//               ].map((item, idx) => (
//                 <motion.li 
//                   key={item.t} 
//                   initial={{ x: -10, opacity: 0 }}
//                   whileInView={{ x: 0, opacity: 1 }}
//                   transition={{ delay: idx * 0.1 }}
//                   className="flex items-start gap-4 p-3 rounded-xl hover:bg-green-50 transition-colors"
//                 >
//                   <CheckCircle size={22} className="shrink-0 text-green-500" strokeWidth={3} />
//                   <span className="text-[16px]">
//                     <span className="font-bold text-[#333]">{item.t}</span> — <span className="text-[#555] font-medium">{item.d}</span>
//                   </span>
//                 </motion.li>
//               ))}
//             </ul>
//           </motion.div>
//         </motion.div>

//         {/* Row 2 Grid */}
//         <div className="grid md:grid-cols-2 gap-10 mb-10">
//           <motion.div 
//             initial={{ opacity: 0, x: -30 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true }}
//             className="bg-white p-10 pt-12 rounded-[2rem] shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-gray-100"
//           >
//             <h3 
//               className="text-[26px] font-bold mb-6"
//               style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//             >
//               How Tajweed Enhances Recitation
//             </h3>
//             <p className="text-[#555] text-[16px] leading-[1.8] mb-6 font-medium">
//               Tajweed shapes every letter leaving the tongue, stretching vowels, and pausing exactly where intended. Teachers demonstrate live, practice immediately, and within weeks recitations flow smoothly.
//             </p>
//             <p className="text-[#555] text-[16px] leading-[1.8] font-medium">
//               Family prayers gain harmony. Children lead prayers without stumbling; adults feel rhythm in their chest, and listeners are moved by the beauty.
//             </p>
//           </motion.div>

//           <motion.div 
//             initial={{ opacity: 0, x: 30 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true }}
//             className="bg-white p-10 pt-12 rounded-[2rem] shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-gray-100"
//           >
//             <h3 
//               className="text-[26px] font-bold mb-6"
//               style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//             >
//               Who Should Learn Tajweed?
//             </h3>
//             <p className="text-[#555] text-[16px] leading-[1.8] font-medium">
//               Beginners, housewives, working adults, teens, retirees, and Hifz students. Kids from age 7 join with easy-to-follow rules. Adults refine rusty recitations. Everyone learns at their own pace in a comfortable environment.
//             </p>
//             <div className="mt-8 grid grid-cols-2 gap-4">
//                <div className="p-4 bg-green-50 rounded-2xl text-center border border-green-100">
//                   <div className="text-2xl font-bold text-green-700">7+</div>
//                   <div className="text-xs font-bold uppercase text-green-600">Min Age</div>
//                </div>
//                <div className="p-4 bg-green-50 rounded-2xl text-center border border-green-100">
//                   <div className="text-2xl font-bold text-green-700">1-on-1</div>
//                   <div className="text-xs font-bold uppercase text-green-600">Lessons</div>
//                </div>
//             </div>
//           </motion.div>
//         </div>

//         {/* Contact Block */}
//         <motion.div 
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           className="bg-white p-10 md:p-14 rounded-[2.5rem] shadow-[0_20px_60px_rgba(0,0,0,0.06)] border border-gray-100 max-w-3xl mx-auto overflow-hidden relative"
//         >
//           <div className="absolute top-0 right-0 w-32 h-32 bg-green-500/10 rounded-bl-full"></div>
          
//           <h3 
//             className="text-[28px] md:text-[32px] font-bold mb-6 leading-tight"
//             style={{ fontFamily: "'Libre Baskerville', serif", color: BRAND_GREEN }}
//           >
//             Contact Al Qirat Online Quran Academy
//           </h3>
//           <p className="text-[#555] text-[17px] leading-[1.8] mb-8 font-medium">
//             Phone calls connect you directly to our team for schedules and course inquiries. WhatsApp is available for quick messages. Responses are fast even at odd hours.
//           </p>
//           <div className="mb-10 p-6 bg-gray-50 rounded-2xl border-l-4 border-green-500">
//             <p className="text-[17px] font-bold text-[#333] flex items-center gap-3">
//                <Phone size={20} className="text-green-600" />
//                Phone: <span className="text-[#333] font-medium">+92 315 5141289</span>
//             </p>
//           </div>
//           <motion.button 
//             whileHover={{ scale: 1.03, boxShadow: "0 10px 25px rgba(40, 167, 69, 0.3)" }}
//             whileTap={{ scale: 0.98 }}
//             className="w-full md:w-auto text-white px-12 py-5 rounded-2xl font-bold text-[18px] tracking-wide transition-all shadow-xl bg-gradient-to-r from-[#28a745] to-[#147a44]"
//           >
//             Book Free Trial / Contact Us
//           </motion.button>
//         </motion.div>
//       </main>

//       {/* Footer */}
//       <footer className="bg-white border-t border-gray-100 mt-24">
//         <div className="max-w-7xl mx-auto px-8 lg:px-12 py-20 grid md:grid-cols-3 gap-16 lg:gap-24">
//           <div className="space-y-8">
//             <div className="flex items-center gap-3">
//                <div className="w-10 h-10 bg-green-600 rotate-45 flex items-center justify-center rounded-lg shadow-lg">
//                   <span className="rotate-[-45deg] text-[10px] font-black text-white">ALQ</span>
//                </div>
//                <span className="text-2xl font-black tracking-tighter" style={{ color: BRAND_GREEN }}>AL QIRAT</span>
//             </div>
//             <p className="text-[#888] text-[15px] leading-[1.9] font-medium">
//               Online Quran teaching Pakistan offers modern teaching methods for all non-Arabic speakers Muslims who want to learn Arabic, & Quran Islamic studies.
//             </p>
//           </div>

//           <div className="grid grid-cols-2 gap-8">
//             <div>
//               <h4 className="font-bold text-[#333] mb-8 text-[13px] uppercase tracking-[0.2em]">Useful Links</h4>
//               <ul className="space-y-5 text-[15px] text-[#888] font-semibold">
//                 <li><a href="#" className="hover:text-green-600 transition-colors">About Us</a></li>
//                 <li><a href="#" className="hover:text-green-600 transition-colors">Feature</a></li>
//                 <li><a href="#" className="hover:text-green-600 transition-colors">Services</a></li>
//               </ul>
//             </div>
//             <div className="pt-[52px]">
//               <ul className="space-y-5 text-[15px] text-[#888] font-semibold">
//                 <li><a href="#" className="hover:text-green-600 transition-colors">Blog</a></li>
//                 <li><a href="#" className="hover:text-green-600 transition-colors">Contact Us</a></li>
//                 <li><a href="#" className="hover:text-green-600 transition-colors">Fees</a></li>
//               </ul>
//             </div>
//           </div>

//           <div>
//             <h4 className="font-bold text-[#333] mb-8 text-[13px] uppercase tracking-[0.2em]">Follow Us</h4>
//             <p className="text-[#888] text-[15px] mb-8 font-medium">Don't miss our future updates! Get Subscribed Today!</p>
//             <div className="flex gap-4">
//               {[Facebook, Instagram, Linkedin].map((Icon, i) => (
//                 <motion.a 
//                   key={i} 
//                   whileHover={{ y: -5, backgroundColor: BRAND_GREEN, color: '#fff', borderColor: BRAND_GREEN }}
//                   href="#" 
//                   className="w-12 h-12 border border-gray-200 rounded-2xl flex items-center justify-center text-[#999] transition-all bg-white"
//                 >
//                   <Icon size={22} />
//                 </motion.a>
//               ))}
//             </div>
//           </div>
//         </div>

//         <div className="bg-[#5d4a3e] py-8 text-center relative overflow-hidden">
//           <div className="absolute inset-0 bg-white/5 opacity-10"></div>
//           <p className="text-white text-[13px] font-bold tracking-widest relative z-10 opacity-90">
//             © 2022-2025 AL QIRAT ONLINE ACADEMY. ALL RIGHTS RESERVED
//           </p>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default App;

// import React, { useState, useEffect,useRef } from 'react';
// import logo from './assets/mqoelogo.png';

// const AnimatedCounter = ({ end, duration = 2000 }) => {
//   const [count, setCount] = useState(0);
//   const countRef = useRef(null);
//   const [isVisible, setIsVisible] = useState(false);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setIsVisible(true);
//         }
//       },
//       { threshold: 0.1 }
//     );

//     if (countRef.current) {
//       observer.observe(countRef.current);
//     }

//     return () => observer.disconnect();
//   }, []);

//   useEffect(() => {
//     if (!isVisible) return;

//     let start = 0;
//     const increment = end / (duration / 16);
//     const timer = setInterval(() => {
//       start += increment;
//       if (start >= end) {
//         setCount(end);
//         clearInterval(timer);
//       } else {
//         setCount(Math.floor(start));
//       }
//     }, 16);

//     return () => clearInterval(timer);
//   }, [isVisible, end, duration]);

//   return <span ref={countRef}>{count.toLocaleString()}</span>;
// };

// // Main App Component
// const App = () => {
//    const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isServicesOpen, setIsServicesOpen] = useState(false);
//   const [formSubmitted, setFormSubmitted] = useState(false);
//   const [userName, setUserName] = useState('');

//   useEffect(() => {
//     const link = document.createElement('link');
//     link.rel = 'stylesheet';
//     link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css';
//     document.head.appendChild(link);
//   }, []);

//   const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const name = e.target.elements.name.value;
//     setUserName(name);
//     setFormSubmitted(true);
//   };

//   const serviceOptions = [
//     { name: "Noorani Qaida", link: "#services" },
//     { name: "Tajweed-e-Quran", link: "#services" },
//     { name: "Basic Islamic Educations", link: "#services" }
//   ];

//   return (
//     <div className="font-['Inter'] text-[#1a3a2a] bg-white pt-20 overflow-x-hidden scroll-smooth">
//       {/* CSS Styles injected via Template Literal to maintain exactness */}
//     <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;700;800&display=swap');
        
//         :root {
//             --primary-green: #147a44;
//             --submit-brown: #634d3a;
//             --accent-lime: #a6ff00;
//         }

//         body {
//             font-family: 'Inter', sans-serif;
//         }

//         .nav-link {
//             font-weight: 600;
//             color: #1a3a2a;
//             transition: color 0.3s;
//             display: flex;
//             align-items: center;
//             gap: 4px;
//             cursor: pointer;
//         }

//         .nav-link:hover {
//             color: var(--primary-green);
//         }

//         .dropdown-menu {
//             position: absolute;
//             top: 100%;
//             left: 0;
//             background: white;
//             min-width: 220px;
//             box-shadow: 0 10px 25px rgba(0,0,0,0.1);
//             border-radius: 8px;
//             padding: 10px 0;
//             opacity: 0;
//             visibility: hidden;
//             transform: translateY(10px);
//             transition: all 0.3s ease;
//             border-top: 3px solid var(--primary-green);
//         }

//         .group:hover .dropdown-menu {
//             opacity: 1;
//             visibility: visible;
//             transform: translateY(0);
//         }

//         .dropdown-item {
//             padding: 10px 20px;
//             display: block;
//             color: #1a3a2a;
//             font-weight: 500;
//             transition: all 0.2s;
//         }

//         .dropdown-item:hover {
//             background-color: #f4fbf7;
//             color: var(--primary-green);
//             padding-left: 25px;
//         }

//         .green-pill {
//             background-color: #e9f5ee;
//             color: var(--primary-green);
//             padding: 8px 16px;
//             border-radius: 25px;
//             font-size: 14px;
//             font-weight: 600;
//             display: flex;
//             align-items: center;
//             gap: 8px;
//         }

//         .course-card {
//             background: white;
//             border-radius: 20px;
//             padding: 40px 30px;
//             text-align: center;
//             box-shadow: 0 10px 30px rgba(0,0,0,0.05);
//             transition: transform 0.3s ease;
//             height: 100%;
//             display: flex;
//             flex-direction: column;
//             justify-content: space-between;
//         }

//         .course-card:hover {
//             transform: translateY(-10px);
//         }

//         .stat-card {
//             background: rgba(255, 255, 255, 0.1);
//             backdrop-filter: blur(12px);
//             padding: 40px 20px;
//             border-radius: 24px;
//             text-align: center;
//             color: white;
//             border: 1px solid rgba(255, 255, 255, 0.2);
//             transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
//             position: relative;
//             overflow: hidden;
//             box-shadow: 0 15px 35px rgba(0,0,0,0.2);
//             transform-style: preserve-3d;
//             perspective: 1000px;
//         }

//         .stat-card:hover {
//             transform: translateY(-10px) rotateX(5deg) rotateY(5deg);
//             border-color: var(--accent-lime);
//             box-shadow: 0 25px 50px rgba(0,0,0,0.3), 0 0 20px rgba(166, 255, 0, 0.2);
//         }

//         .stat-card::before {
//             content: '';
//             position: absolute;
//             top: -50%;
//             left: -50%;
//             width: 200%;
//             height: 200%;
//             background: radial-gradient(circle, rgba(166, 255, 0, 0.1) 0%, transparent 70%);
//             opacity: 0;
//             transition: opacity 0.3s;
//         }

//         .stat-card:hover::before {
//             opacity: 1;
//         }

//         .form-input {
//             width: 100%;
//             border: 1px solid #ced4da;
//             padding: 15px;
//             border-radius: 4px;
//             margin-bottom: 15px;
//             outline: none;
//             transition: border-color 0.3s;
//         }

//         .form-input:focus {
//             border-color: var(--primary-green);
//         }

//         .btn-submit {
//             background-color: var(--submit-brown);
//             color: white;
//             width: 100%;
//             padding: 15px;
//             border-radius: 4px;
//             font-weight: 700;
//             text-transform: capitalize;
//             font-size: 18px;
//             transition: opacity 0.3s;
//             cursor: pointer;
//         }

//         .btn-submit:hover {
//             opacity: 0.9;
//         }

//         .whatsapp-float {
//             position: fixed;
//             bottom: 30px;
//             right: 30px;
//             background-color: #25d366;
//             color: white;
//             width: 60px;
//             height: 60px;
//             border-radius: 50%;
//             display: flex;
//             align-items: center;
//             justify-content: center;
//             font-size: 30px;
//             box-shadow: 2px 5px 15px rgba(0,0,0,0.3);
//             z-index: 1000;
//             transition: transform 0.3s;
//         }

//         .whatsapp-float:hover {
//             transform: scale(1.1);
//         }

//         .stats-bg-glow {
//             position: absolute;
//             width: 300px;
//             height: 300px;
//             background: var(--accent-lime);
//             filter: blur(150px);
//             opacity: 0.15;
//             border-radius: 50%;
//             pointer-events: none;
//         }
//       `}</style>

//       {/* WhatsApp Button */}
//        <a href="https://wa.me/+923155141289" target="_blank" rel="noopener noreferrer" className="whatsapp-float">
//         <i className="fab fa-whatsapp"></i>
//       </a>

//           {/* Header */}
//      <header className="py-4 px-6 lg:px-24 bg-white fixed top-0 left-0 right-0 z-[1000] shadow-md">
//   <div className="max-w-7xl mx-auto flex justify-between items-center">
//     <div className="flex items-center gap-3">
//       {/* Logo Section */}
//       <div className="flex items-center">
//         <img 
//           src={logo} 
//           alt="Madina Quran Online Education" 
//           className="h-16 w-auto object-contain" // Height ko logo ke design ke mutabiq 12 ya 14 rakhein
//         />
//       </div>
      
//       {/* Brand Name */}
//       <span className="text-xl font-extrabold text-[#147a44] hidden lg:block">
//         Madina Quran Online Education
//       </span>
//     </div>
    
//     <nav className="hidden md:flex gap-10">
//       <a href="#" className="nav-link">Home</a>
      
//       {/* Desktop Dropdown */}
//       <div className="relative group">
//         <div className="nav-link cursor-pointer">
//           Services <i className="fas fa-chevron-down text-[10px] ml-1"></i>
//         </div>
//         <div className="dropdown-menu">
//           {serviceOptions.map((option, idx) => (
//             <a key={idx} href={option.link} className="dropdown-item">{option.name}</a>
//           ))}
//         </div>
//       </div>

//       <a href="#contact" className="nav-link">Contact Us</a>
//     </nav>

//     <div className="md:hidden text-2xl cursor-pointer" onClick={toggleMenu}>
//       <i className={isMenuOpen ? "fas fa-times" : "fas fa-bars"}></i>
//     </div>
//   </div>
// </header>

//       {/* Mobile Nav */}
//       {isMenuOpen && (
//         <div className="md:hidden fixed top-[72px] left-0 right-0 bg-white p-5 flex flex-col gap-4 shadow-xl z-[999] border-t max-h-[80vh] overflow-y-auto">
//           <a href="#" className="nav-link py-2 border-b" onClick={toggleMenu}>Home</a>
          
//           {/* Mobile Dropdown Toggle */}
//           <div className="border-b">
//             <div className="nav-link py-2 justify-between" onClick={() => setIsServicesOpen(!isServicesOpen)}>
//               Services <i className={`fas fa-chevron-${isServicesOpen ? 'up' : 'down'} text-sm`}></i>
//             </div>
//             {isServicesOpen && (
//               <div className="pl-4 pb-2 bg-gray-50 flex flex-col">
//                 {serviceOptions.map((option, idx) => (
//                   <a key={idx} href={option.link} className="py-2 text-sm font-medium text-gray-600" onClick={toggleMenu}>{option.name}</a>
//                 ))}
//               </div>
//             )}
//           </div>
          
//           <a href="#contact" className="nav-link py-2" onClick={toggleMenu}>Contact Us</a>
//         </div>
//       )}

//       {/* Hero Section */}
//       <section className="bg-[#f4fbf7] py-16 px-6 lg:px-24">
//         <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
//           <div>
//             <h1 className="text-4xl lg:text-6xl font-extrabold text-[#147a44] leading-tight mb-6">
//               Online Quran Teaching With Expert Tutors
//             </h1>
//             <p className="text-lg text-gray-700 mb-8 leading-relaxed">
//               Madina Quran Online Education offers professional online Quran teaching for kids and adults worldwide. Learn the Holy Quran with Tajweed through one-to-one live classes with qualified male and female teachers.
//             </p>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
//               <div className="green-pill"><i className="fas fa-check-circle"></i> One-to-One Quran Classes</div>
//               <div className="green-pill"><i className="fas fa-check-circle"></i> Certified Male & Female Tutors</div>
//               <div className="green-pill"><i className="fas fa-check-circle"></i> Flexible Class Timings</div>
//             </div>
//             <a href="#contact" className="inline-block bg-[#147a44] text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-[#0d5e34] transition shadow-lg">Get Started Now</a>
//           </div>
//           <div className="relative">
//             <img src="https://images.unsplash.com/photo-1585036156171-384164a8c675" alt="Holy Quran" className="rounded-3xl shadow-2xl w-full object-cover" />
//           </div>
//         </div>
//       </section>

//       {/* Stats Section with Animations and Glow */}
//       <section className="bg-[#147a44] py-24 px-6 relative overflow-hidden">
//         {/* Background Glowing Effects */}
//         <div className="stats-bg-glow -top-20 -left-20"></div>
//         <div className="stats-bg-glow -bottom-20 -right-20"></div>

//         <div className="max-w-7xl mx-auto text-center mb-16 relative z-10">
//           <h2 className="text-4xl font-bold text-white mb-4">Trusted Online Quran Teaching Academy Worldwide</h2>
//           <p className="text-green-100 opacity-90 text-lg">Thousands of students trust our academy for professional Quran learning.</p>
//         </div>

//         <div className="max-w-6xl mx-auto grid grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
//           <div className="stat-card">
//             <div className="text-5xl font-black text-[#a6ff00] mb-3">
//               <AnimatedCounter end={5000} />+
//             </div>
//             <div className="text-sm font-bold uppercase tracking-[2px]">Students</div>
//           </div>

//           <div className="stat-card">
//             <div className="text-5xl font-black text-[#a6ff00] mb-3">
//               <AnimatedCounter end={20} />+
//             </div>
//             <div className="text-sm font-bold uppercase tracking-[2px]">Countries</div>
//           </div>

//           <div className="stat-card">
//             <div className="text-5xl font-black text-[#a6ff00] mb-3">
//               <AnimatedCounter end={100} />+
//             </div>
//             <div className="text-sm font-bold uppercase tracking-[2px]">Expert Tutors</div>
//           </div>

//           <div className="stat-card">
//             <div className="text-5xl font-black text-[#a6ff00] mb-3">
//               <AnimatedCounter end={10} />
//             </div>
//             <div className="text-sm font-bold uppercase tracking-[2px]">Years Experience</div>
//           </div>
//         </div>
//       </section>

//       {/* Services Section */}
//       <section id="services" className="bg-[#f4fbf7] py-20 px-6">
//         <div className="max-w-7xl mx-auto text-center mb-16">
//           <h2 className="text-4xl font-bold mb-4 text-[#147a44]">Our Online Quran Courses</h2>
//           <p className="text-gray-600 max-w-3xl mx-auto">At Madina Quran Online Education, we offer specialized courses for kids and adults designed to make learning easy and effective.</p>
//         </div>
//         <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8">
//           <div className="course-card">
//             <div>
//               <div className="text-5xl mb-6">📖</div>
//               <h3 className="text-xl font-bold text-[#147a44] mb-4">Noorani Qaida Course</h3>
//               <p className="text-gray-600 mb-8">Basic Quran reading skills and Arabic letter pronunciation for beginners. Ideal for kids starting their journey.</p>
//             </div>
//             <a href="#contact" className="bg-[#147a44] text-white px-8 py-3 rounded-lg font-bold inline-block">Learn More</a>
//           </div>
//           <div className="course-card">
//             <div>
//               <div className="text-5xl mb-6">🕌</div>
//               <h3 className="text-xl font-bold text-[#147a44] mb-4">Quran with Tajweed</h3>
//               <p className="text-gray-600 mb-8">Learn to recite the Holy Quran correctly with proper Tajweed rules and beautiful pronunciation.</p>
//             </div>
//             <a href="#contact" className="bg-[#147a44] text-white px-8 py-3 rounded-lg font-bold inline-block">Learn More</a>
//           </div>
//           <div className="course-card">
//             <div>
//               <div className="text-5xl mb-6">⭐</div>
//               <h3 className="text-xl font-bold text-[#147a44] mb-4">Islamic Education</h3>
//               <p className="text-gray-600 mb-8">Strengthen your spiritual foundation through our comprehensive Islamic studies and Hifz program, featuring expert guidance and personalized daily tracking.</p>
//             </div>
//             <a href="#contact" className="bg-[#147a44] text-white px-8 py-3 rounded-lg font-bold inline-block">Learn More</a>
//           </div>
//         </div>
//       </section>

//       {/* Contact Form Section */}
//       <section id="contact" className="py-20 px-6 bg-white">
//         <div className="max-w-3xl mx-auto text-center mb-10">
//           <h2 className="text-3xl font-bold text-[#147a44]">Contact Us / Register</h2>
//           <p className="text-gray-500 mt-2">Fill the form below and we'll get back to you shortly to schedule your trial class.</p>
//         </div>
//         <div className="max-w-xl mx-auto">
//           {!formSubmitted ? (
//             <form className="space-y-4" onSubmit={handleSubmit}>
//               <input type="text" name="name" className="form-input" placeholder="Your Name" required />
//               <input type="tel" name="phone" className="form-input" placeholder="Phone (e.g. +1...)" required />
//               <input type="email" name="email" className="form-input" placeholder="Email Address" required />
//               <textarea name="message" className="form-input h-32" placeholder="Your Message or Chosen Course"></textarea>
//               <button type="submit" className="btn-submit">SUBMIT APPLICATION</button>
//             </form>
//           ) : (
//             <div className="text-center p-10 bg-green-50 rounded-lg">
//               <i className="fas fa-check-circle text-5xl text-[#147a44] mb-4"></i>
//               <h3 className="text-2xl font-bold text-[#147a44] mb-2">Thank You, {userName}!</h3>
//               <p className="text-gray-600">Your application has been received. Our team will contact you within 24 hours.</p>
//               <button onClick={() => setFormSubmitted(false)} className="mt-4 text-[#147a44] underline font-bold">Send another message</button>
//             </div>
//           )}
//         </div>
//       </section>

//       {/* Footer */}
//       <footer className="bg-gray-50 border-t border-gray-100 py-12 px-6">
//         <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8 mb-8 text-left">
//           <div>
//             <div className="flex items-center gap-2 mb-4">
//               <div className="w-8 h-8 bg-[#147a44] rounded-full flex items-center justify-center text-white font-bold text-xs">MQOE</div>
//               <span className="text-lg font-extrabold text-[#147a44]">Madina Quran Online Education</span>
//             </div>
//             <p className="text-gray-500 text-sm">Professional Online Quran Academy providing quality education worldwide for over a decade.</p>
//           </div>
//           <div>
//             <h4 className="font-bold text-[#147a44] mb-4">Quick Links</h4>
//             <ul className="text-gray-500 text-sm space-y-2">
//               <li><a href="#" className="hover:text-[#147a44]">Home</a></li>
//               <li><a href="#services" className="hover:text-[#147a44]">Services</a></li>
//               <li><a href="#contact" className="hover:text-[#147a44]">Register Now</a></li>
//             </ul>
//           </div>
//           <div>
//             <h4 className="font-bold text-[#147a44] mb-4">Support</h4>
//             <ul className="text-gray-500 text-sm space-y-2">
//               <li><i className="fas fa-envelope mr-2"></i> madinaquranonlineeducation@gmail.com</li>
//               <li><i className="fas fa-phone mr-2"></i> +92 315 5141289</li>
//             </ul>
//           </div>
//         </div>
//         <div className="border-t border-gray-200 pt-8 text-center text-gray-400 text-xs">
//           <p>&copy; 2024 Madina Quran Online Education. All Rights Reserved.</p>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default App;



// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import HomePage from './QHome'; // Jahan aapne home rakha hai
// import TajweedPage from './Tajweed'; // Jahan aapne tajweed rakha hai
// import All from './All';
// import Noorani from './Noorani.jsx';
// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* '/' ka matlab hai jab site khule to Home dikhay */}
//         <Route path="/" element={<HomePage />} />
        
//         {/* '/tajweed' par aapka doosra page khulega */}
//         <Route path="/tajweed" element={<TajweedPage />} />


//         <Route path="/all" element={<All />} />

//         <Route path="/noorani" element={<Noorani />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;




// import TigersCommunication from './pages/tc';

// function App() {
//   return <TigersCommunication />;
// }
// export default App;

import React, { useState, useEffect,useRef } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { motion, AnimatePresence } from 'framer-motion';
import emailjs from '@emailjs/browser';
import { 
  Heart, Smile, Star, Camera, Phone, MapPin, 
  Menu, X, Palette, Baby, Cloud, Sun, Music, 
  Sparkles, Play, GraduationCap, ShieldCheck, ExternalLink,
  Users, BookOpen, Mail, Send, CheckCircle,Volume2, VolumeX,
} from 'lucide-react';

// --- IMAGES IMPORT ---
// React mein local images ko aise import kiya jata hai
// Agar aapke paas images hain to in lines ko uncomment kar dein:
import img1 from './assets/daycare-calgary-indoor-play-area.jpeg';
import img2 from './assets/preschool-learning-activities-calgary.jpeg';
import img3 from './assets/little-aurora-kids-creative-arts-crafts.jpeg';
import img4 from './assets/safe-childcare-environment-calgary-ne.jpeg';
import img5 from './assets/toddler-social-development-little-aurora.jpeg';
import img6 from './assets/infant-care-services-calgary-alberta.jpeg';
import img7 from './assets/little-aurora-kids-daycare-exterior-sign.jpeg';

import video1 from './assets/daycare-tour-calgary-little-aurora-kids.mp4';
import video2 from './assets/kids-daily-activities-video-calgary.mp4';
import video3 from './assets/trusted-childcare-provider-calgary-review.mp4';

const youtubeMusicId = "dQw4w9WgXcQ";
// Images ka array taake loops mein use ho sakein
const localImages = [img1, img2, img3, img4, img5, img6,img7];


const PLACEHOLDERS = [
  'https://images.unsplash.com/photo-1502086223501-7ea24ec394e0?q=80&w=800',
  'https://images.unsplash.com/photo-1516627145497-ae6968895b74?q=80&w=800',
  'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?q=80&w=800',
  'https://images.unsplash.com/photo-1587654780291-39c9404d746b?q=80&w=800',
  'https://images.unsplash.com/photo-1472162072942-cd5147eb3902?q=80&w=800',
  'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?q=80&w=800'
];

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2 }
  }
};

const RainbowIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" className={className}>
    <path d="M6 18a6 6 0 0 1 12 0" stroke="#FF6B6B" />
    <path d="M4 18a8 8 0 0 1 16 0" stroke="#FFD93D" />
    <path d="M2 18a10 10 0 0 1 20 0" stroke="#6BCB77" />
  </svg>
);

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = ['Home', 'About', 'Programs', 'Gallery', 'Location'];

  return (
    <nav className={`fixed w-full z-50 transition-all duration-500 ${scrolled ? 'bg-white/90 backdrop-blur-lg shadow-md py-2' : 'bg-transparent py-5'}`}>
      <div className="container mx-auto px-6 flex justify-between items-center">
        <motion.div whileHover={{ scale: 1.05 }} className="flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
          <div className="bg-gradient-to-tr from-pink-400 to-blue-400 p-2 rounded-full shadow-md">
            <RainbowIcon className="w-6 h-6 text-white" />
          </div>
          <span className="text-2xl font-black bg-gradient-to-r from-pink-600 to-blue-600 bg-clip-text text-transparent">
            Little Aurora Kids
          </span>
        </motion.div>

        <div className="hidden md:flex gap-8 items-center">
          {navItems.map((item) => (
            <a key={item} href={`#${item.toLowerCase()}`} className="font-bold text-gray-600 hover:text-pink-500 transition-colors text-sm uppercase tracking-widest">
              {item}
            </a>
          ))}
          <a href="#contact" className="bg-pink-500 text-white px-6 py-2.5 rounded-full font-bold text-sm shadow-xl shadow-pink-200 hover:bg-pink-600 transition-all">
            Join Now
          </a>
        </div>

        <button className="md:hidden text-gray-700" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <X /> : <Menu />}
        </button>
      </div>
      
      <AnimatePresence>
        {isOpen && (
          <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} className="md:hidden bg-white shadow-2xl absolute w-full border-t">
            {navItems.map((item) => (
              <a key={item} href={`#${item.toLowerCase()}`} onClick={() => setIsOpen(false)} className="block px-8 py-4 text-gray-700 font-bold border-b border-gray-100">
                {item}
              </a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

const Hero = () => (
  <header id="home" className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-[#FFFDF5]">
    <div className="absolute top-20 left-10 w-[500px] h-[500px] bg-pink-100/50 rounded-full blur-[100px] opacity-60 animate-pulse"></div>
    <div className="absolute bottom-20 right-10 w-[500px] h-[500px] bg-blue-100/50 rounded-full blur-[100px] opacity-60 animate-pulse"></div>

    <div className="container mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center relative z-10">
      <motion.div initial="hidden" animate="visible" variants={staggerContainer}>
        <motion.div variants={fadeInUp} className="inline-block bg-pink-100 text-pink-600 px-4 py-1.5 rounded-full text-xs font-black uppercase tracking-widest mb-6">
          Best Dayhome in Calgary
        </motion.div>
        <motion.h1 variants={fadeInUp} className="text-6xl md:text-8xl font-black text-gray-900 leading-[1.1] mb-6 tracking-tighter">
          Nurturing <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-purple-500 to-blue-500 animate-gradient-x">
            Little Dreams
          </span>
        </motion.h1>
        <motion.p variants={fadeInUp} className="text-xl text-gray-600 max-w-lg mb-10 leading-relaxed font-medium">
          Premium childcare in Calgary. Where every child's growth is celebrated with love and creativity.
        </motion.p>
        <motion.div variants={fadeInUp} className="flex flex-wrap gap-4">
          <a href="#contact">
  <button className="bg-pink-500 text-white px-10 py-5 rounded-full font-black shadow-2xl shadow-pink-200 hover:scale-105 transition-transform flex items-center gap-2">
    Enroll Now <Heart size={20} fill="white" />
  </button>
</a>
          <button className="bg-white/50 backdrop-blur-md text-gray-800 px-10 py-5 rounded-full font-black shadow-lg border border-white/80 hover:bg-white transition-colors">
            Our Mission
          </button>
        </motion.div>
      </motion.div>

      <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1 }} className="relative">
        <div className="relative z-10 bg-white/40 backdrop-blur-sm p-4 rounded-[80px] shadow-2xl rotate-3 border-8 border-white/60 group">
          <img 
            src="./assets/1.jpeg" 
            alt="Little Aurora Kids Activity" 
            className="rounded-[70px] w-full aspect-square object-cover transition-transform duration-700 group-hover:rotate-0"
            onError={(e) => { e.target.src = 'https://images.unsplash.com/photo-1516627145497-ae6968895b74?q=80&w=800'; }}
          />
          <div className="absolute -bottom-8 -left-8 bg-yellow-400 p-6 rounded-3xl shadow-2xl animate-bounce">
            <Sun className="text-white" size={40} />
          </div>
        </div>
      </motion.div>
    </div>
  </header>
);

const About = () => {
  return (
    <section id="about" className="py-32 bg-[#FFFDF5] overflow-hidden">
      <div className="container mx-auto px-6">
        {/* Main grid structure changed to focus on text content */}
        <div className="grid lg:grid-cols-5 gap-20 items-center">
          
          {/* Left Column: Taking less space for a more balanced text layout */}
          <motion.div 
            initial="hidden" 
            whileInView="visible" 
            viewport={{ once: true }} 
            variants={fadeInUp} 
            className="relative lg:col-span-2 hidden lg:block"
          >
            {/* Added a subtle graphic element instead of photos to fill space elegantly */}
            <div className="bg-white p-16 rounded-[80px] shadow-3xl border border-white text-center">
              <Sparkles size={80} className="text-pink-300 mx-auto mb-6" />
              <div className="w-24 h-1 bg-gray-200 mx-auto rounded-full mb-6"></div>
              <h3 className="text-3xl font-black text-gray-900 leading-snug tracking-tighter mb-4 italic">
                Our Calgary <br/> Facility
              </h3>
              <p className="text-sm text-gray-400 font-medium">Design specifically for child development and comfort.</p>
              
              {/* Optional: Add a simple link or call-to-action */}
              {/* <div className="mt-8 text-xs font-black uppercase text-pink-500 tracking-widest cursor-pointer">Explore More</div> */}
            </div>
          </motion.div>

          {/* Right Column: Main Content area with increased emphasis */}
          <motion.div 
            initial="hidden" 
            whileInView="visible" 
            viewport={{ once: true }} 
            variants={staggerContainer} 
            className="lg:col-span-3 lg:pl-10"
          >
            <motion.h2 
              variants={fadeInUp} 
              className="text-5xl md:text-7xl font-black text-gray-900 mb-8 tracking-tighter leading-none"
            >
              A Second Home <br />
              <span className="text-pink-500 italic">For Your Child</span>
            </motion.h2>
            
            <motion.p 
              variants={fadeInUp} 
              className="text-xl text-gray-600 mb-12 leading-relaxed font-medium"
            >
              At Little Aurora, we prioritize safety, creative exploration, and social development. Our certified service provide the personalized attention your child deserves in our Calgary facility.
            </motion.p>
            
            {/* Redesigned grid for feature cards to look more like distinct cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-10">
              {[
                { icon: GraduationCap, title: 'Expert Team', desc: 'Passionate and certified educators.' },
                { icon: ShieldCheck, title: 'Total Safety', desc: 'Secure facility with 24/7 monitoring.' },
                { icon: Users, title: 'Social Growth', desc: 'Building confidence and social skills.' },
                { icon: Sparkles, title: 'Creative Art', desc: 'Focusing on imagination and crafts.' },
              ].map((item, i) => (
                <motion.div 
                  key={i} 
                  variants={fadeInUp} 
                  className="bg-white p-8 rounded-[40px] shadow-sm border border-gray-100 flex gap-5 items-start group hover:border-pink-200 transition-all duration-300 cursor-default"
                >
                  <div className="bg-pink-100 p-4 rounded-2xl text-pink-500 group-hover:bg-pink-500 group-hover:text-white transition-colors duration-300">
                    <item.icon size={28} />
                  </div>
                  <div className="flex-grow pt-1">
                    <h4 className="font-black text-gray-900 text-xl mb-1 tracking-tight">{item.title}</h4>
                    <p className="text-sm text-gray-500 font-medium leading-relaxed">{item.desc}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

const Programs = () => {
  const programs = [
    { title: 'Infant Oasis', age: '0-18 Months', desc: 'Nurturing care focused on sensory play and comfort.', color: 'bg-blue-500', icon: Baby },
    { title: 'Toddler Town', age: '1.5-3 Years', desc: 'Active exploration and language building through play.', color: 'bg-pink-500', icon: Smile },
    { title: 'Preschool Prep', age: '3-5 Years', desc: 'Pre-K curriculum fostering social and mental growth.', color: 'bg-yellow-500', icon: BookOpen }
  ];

  return (
    <section id="programs" className="py-32 bg-[#FDFCFB]">
      <div className="container mx-auto px-6">
        <div className="text-center mb-20">
          <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="text-5xl md:text-7xl font-black text-gray-900 mb-6 tracking-tighter">Our Programs</motion.h2>
          <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} className="text-gray-500 max-w-xl mx-auto text-lg font-medium italic">Discover our specialized learning paths for every age group.</motion.p>
        </div>
        <div className="grid md:grid-cols-3 gap-10">
          {programs.map((p, i) => (
            <motion.div key={i} whileHover={{ y: -15 }} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="bg-white p-12 rounded-[60px] shadow-2xl shadow-gray-200/50 border border-white/60 group relative overflow-hidden">
              <div className={`${p.color} w-24 h-24 rounded-[30px] flex items-center justify-center mb-8 shadow-xl group-hover:scale-110 transition-transform`}>
                <p.icon className="text-white" size={48} />
              </div>
              <h3 className="text-3xl font-black text-gray-900 mb-2">{p.title}</h3>
              <span className="text-pink-500 font-black text-sm block mb-6 uppercase tracking-[0.2em]">{p.age}</span>
              <p className="text-gray-600 text-lg leading-relaxed font-medium">{p.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

const Gallery = () => {
  // SEO-friendly descriptions for images
  const imageDescriptions = [
    "Kids playing with educational toys at Little Aurora Dayhome Calgary",
    "Creative arts and crafts session for preschoolers in Calgary NE",
    "Safe and nurturing indoor play area for toddlers at Little Aurora Kids",
    "Group activities and social learning for children in Calgary childcare",
    "Infant care and early development activities in Calgary dayhome",
    "Outdoor play and physical activities for kids at Little Aurora",
    "Learning through play at premium Calgary childcare center",
    "Happy children in a diverse and inclusive Calgary preschool environment"
  ];

  return (
    <section id="gallery" className="py-32 bg-white" aria-labelledby="gallery-title">
      <div className="container mx-auto px-6 text-center">
        {/* Semantic SEO: Heading with keywords */}
        <h2 id="gallery-title" className="text-5xl md:text-7xl font-black text-gray-900 mb-16 tracking-tighter italic">
          Sweet Memories <span className="sr-only">at Little Aurora Kids Dayhome Calgary</span>
        </h2>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {localImages.map((img, i) => (
            <motion.div 
              key={i} 
              whileHover={{ scale: 1.05 }} 
              className="rounded-[40px] overflow-hidden shadow-xl border-4 border-white aspect-square bg-gray-100"
            >
              <img 
                src={img} 
                className="w-full h-full object-cover" 
                // SEO CRITICAL: Dynamic and descriptive alt tags
                alt={imageDescriptions[i] || `Little Aurora Kids Dayhome Calgary Activity ${i + 1}`}
                loading="lazy" // Performance SEO: Sirf tab load hogi jab user scroll karega
                title="Little Aurora Kids Calgary" // Tooltip for users and bots
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

const VideoSection = () => {
  const [isMuted, setIsMuted] = useState(true);
  const playerRef = useRef(null);
  const [isApiReady, setIsApiReady] = useState(false);
  
  const videoCards = [
    { src: video1, color: "pink", glow: "rgba(236, 72, 153, 0.4)", type: 'video' },
    { src: video2, color: "blue", glow: "rgba(59, 130, 246, 0.4)", type: 'video' },
    { src: video3, color: "yellow", glow: "rgba(250, 204, 21, 0.4)", type: 'video' },
    { src: img4, color: "purple", glow: "rgba(168, 85, 247, 0.4)", type: 'image' }
  ];

  useEffect(() => {
    // Load YouTube API
    if (!window.YT) {
      const tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      window.onYouTubeIframeAPIReady = () => setIsApiReady(true);
    } else {
      setIsApiReady(true);
    }
  }, []);

  useEffect(() => {
    if (isApiReady && !playerRef.current) {
      playerRef.current = new window.YT.Player('youtube-player', {
        height: '0',
        width: '0',
        videoId: youtubeMusicId,
        playerVars: {
          autoplay: 1,
          mute: 1, // Browser rules ke liye shuru mein mute zaroori hai
          loop: 1,
          playlist: youtubeMusicId,
          controls: 0,
          modestbranding: 1,
        },
        events: {
          onReady: (event) => {
            event.target.playVideo();
          }
        }
      });
    }

    // Try to unmute on any interaction (Scroll or Mouse Move)
    const attemptUnmute = () => {
      if (playerRef.current && typeof playerRef.current.unMute === 'function') {
        playerRef.current.unMute();
        playerRef.current.setVolume(50);
        setIsMuted(false);
        // Remove listeners once unmuted successfully
        window.removeEventListener('scroll', attemptUnmute);
        window.removeEventListener('mousemove', attemptUnmute);
        window.removeEventListener('touchstart', attemptUnmute);
      }
    };

    window.addEventListener('scroll', attemptUnmute);
    window.addEventListener('mousemove', attemptUnmute);
    window.addEventListener('touchstart', attemptUnmute);

    return () => {
      window.removeEventListener('scroll', attemptUnmute);
      window.removeEventListener('mousemove', attemptUnmute);
      window.removeEventListener('touchstart', attemptUnmute);
    };
  }, [isApiReady]);

  const handleAutoPlay = () => {
    if (playerRef.current && typeof playerRef.current.playVideo === 'function') {
      playerRef.current.playVideo();
    }
  };

  const handleAutoStop = () => {
    if (playerRef.current && typeof playerRef.current.pauseVideo === 'function') {
      playerRef.current.pauseVideo();
    }
  };

  return (
    <motion.section 
      onViewportEnter={handleAutoPlay}
      onViewportLeave={handleAutoStop}
      viewport={{ amount: 0.1 }}
      className="py-40 bg-white overflow-hidden relative"
    >
      <div id="youtube-player" className="hidden"></div>

      <div className="container mx-auto px-6 mb-20 text-center relative z-10">
        <motion.div 
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          className="inline-block mb-4 px-6 py-2 rounded-full bg-blue-50 text-blue-600 font-bold text-sm tracking-widest uppercase"
        >
          Watch Our Daily Joy
        </motion.div>
        
        <motion.h2 
          initial={{ opacity: 0, y: 20 }} 
          whileInView={{ opacity: 1, y: 0 }} 
          className="text-6xl md:text-8xl font-black text-gray-900 mb-6 tracking-tighter"
        >
          Dayhome <span className="text-pink-500">in Action</span>
        </motion.h2>
        
        <p className="text-xl text-gray-500 font-medium italic mb-8">Vibrant moments from Little Aurora Kids</p>

        {/* Status Indicator */}
        <div className="flex justify-center items-center gap-4 text-gray-400 font-bold uppercase tracking-widest text-xs">
          <div className={`w-2 h-2 rounded-full ${!isMuted ? 'bg-green-500 animate-pulse' : 'bg-gray-300'}`}></div>
          {isMuted ? "Sound restricted by browser - Scroll to enable" : "Sound System Active"}
          {!isMuted && <Volume2 size={16} className="text-pink-500" />}
        </div>
      </div>

      <div className="flex overflow-hidden">
        <motion.div 
          className="flex gap-12 py-20 px-6"
          animate={{ x: [0, -2800] }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop",
              duration: 40,
              ease: "linear",
            },
          }}
        >
          {[...videoCards, ...videoCards, ...videoCards, ...videoCards].map((item, i) => (
            <motion.div 
              key={i} 
              whileHover={{ scale: 1.05, zIndex: 10 }}
              className="flex-shrink-0 w-[500px] md:w-[750px] relative rounded-[80px] overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.1)] aspect-video border-[12px] border-white bg-gray-100 group transition-all duration-500"
              style={{ boxShadow: `0 30px 60px -12px ${item.glow}` }}
            >
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none z-20" 
                   style={{ background: `radial-gradient(circle at center, transparent 30%, ${item.glow} 100%)` }}>
              </div>

              {item.type === 'video' ? (
                <video 
                  src={item.src} 
                  className="w-full h-full object-cover grayscale-[20%] group-hover:grayscale-0 transition-all duration-700"
                  autoPlay 
                  muted 
                  loop 
                  playsInline
                />
              ) : (
                <img src={item.src} className="w-full h-full object-cover" alt="Activity" />
              )}

              <div className="absolute bottom-10 left-10 z-30 flex items-center gap-4">
                <div className="bg-white/90 backdrop-blur-md p-4 rounded-full shadow-xl">
                  <Play className={`text-${item.color}-500 fill-${item.color}-500`} size={24} />
                </div>
                <div className="bg-white/90 backdrop-blur-md px-6 py-2 rounded-full font-black text-gray-900 uppercase tracking-widest text-xs">
                  Live View
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </motion.section>
  );
};


const LocationSection = () => {
  // Updated address as requested
  const address = "41 Corner Ridge Mews NE, Calgary, AB T3N 1X4, Canada";
  
  // Universal link for Apple Maps (iOS) / Google Maps (Other)
  const mapsUrl = `https://maps.apple.com/?q=${encodeURIComponent(address)}`;

  return (
    <section id="location" className="py-32 bg-[#FFFDF5]">
      <div className="container mx-auto px-6">
        <div className="bg-white p-12 md:p-20 rounded-[80px] shadow-3xl border border-white grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="bg-blue-100 text-blue-600 px-5 py-2 rounded-full inline-block font-black text-xs uppercase tracking-[0.3em] mb-8 shadow-sm">Location</div>
            <h2 className="text-5xl md:text-7xl font-black text-gray-900 mb-8 tracking-tighter leading-tight italic">Find Us In <br/>Calgary</h2>
            <p className="text-xl text-gray-600 mb-10 leading-relaxed font-medium">
              Located in the peaceful and secure Corner Ridge area of Calgary, our location is easily accessible for every family.
            </p>
            
            <div className="bg-white p-8 rounded-[40px] mb-10 flex flex-col sm:flex-row items-start sm:items-center gap-6 border border-gray-100 shadow-sm group">
              <div className="bg-pink-100 p-5 rounded-3xl text-pink-500 group-hover:bg-pink-500 group-hover:text-white transition-colors duration-300">
                <MapPin size={40} />
              </div>
              <div className="flex-grow">
                <p className="text-gray-400 font-black uppercase text-xs tracking-widest mb-1">Our Address</p>
                <p className="text-xl font-black text-gray-800 tracking-tight leading-snug">{address}</p>
              </div>
            </div>

            <motion.a 
              href={mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-flex items-center gap-3 bg-gray-900 text-white px-10 py-5 rounded-full font-black text-sm uppercase tracking-widest shadow-2xl hover:bg-pink-600 transition-colors"
            >
              Get Directions <ExternalLink size={18} />
            </motion.a>
          </div>

          <div className="relative rounded-[60px] overflow-hidden shadow-2xl h-[450px] border-8 border-white bg-gray-100 flex items-center justify-center group cursor-pointer"
               onClick={() => window.open(mapsUrl, '_blank')}>
            <div className="absolute inset-0 bg-gradient-to-tr from-pink-500/10 to-blue-500/10 group-hover:opacity-0 transition-opacity"></div>
            <div className="text-center relative z-10 px-8">
              <MapPin size={60} className="text-pink-500 mx-auto mb-4 animate-bounce" />
              <p className="text-gray-500 font-black uppercase tracking-widest text-sm">Corner Ridge Center</p>
              <p className="text-xs text-gray-400 mt-2 font-medium">Calgary, AB T3N 1X4</p>
              <div className="mt-6 bg-white/80 backdrop-blur-sm px-6 py-2 rounded-full text-[10px] font-black text-gray-400 uppercase tracking-tighter opacity-0 group-hover:opacity-100 transition-all transform translate-y-2 group-hover:translate-y-0">
                Open in Maps
              </div>
            </div>
            
            {/* Simple Grid Pattern for Map feel */}
            <div className="absolute inset-0 -z-10 opacity-30" style={{ backgroundImage: 'radial-gradient(#CBD5E1 1px, transparent 1px)', backgroundSize: '20px 20px' }}></div>
          </div>
        </div>
      </div>
    </section>
  );
};

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    const SERVICE_ID = "service_xn8bhn9";
    const TEMPLATE_ID = "template_oxykr8y";
    const PUBLIC_KEY = "fgEZOT7uC0ZTSMDa9";

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY)
      .then((result) => {
          setSubmitted(true);
          setLoading(false);
      }, (error) => {
          alert("Error! Please try again later.");
          setLoading(false);
      });
  };

  return (
   <section id="contact" className="py-20 md:py-32 bg-white relative overflow-hidden">
  <div className="container mx-auto px-4 md:px-6 relative z-10">
    {/* Mobile par rounded corners thode kam kiye hain taaki space bache */}
    <div className="bg-[#f9f9f9] border border-gray-200 rounded-[40px] md:rounded-[100px] p-6 md:p-20 shadow-inner">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={staggerContainer}>
          <motion.div variants={fadeInUp} className="bg-blue-600 text-white px-5 py-2 rounded-full inline-block font-black text-xs uppercase tracking-widest mb-6 md:mb-8">
            Contact Us
          </motion.div>
          <motion.h2 variants={fadeInUp} className="text-5xl md:text-8xl font-black text-gray-900 mb-6 md:mb-8 tracking-tighter leading-none italic">
            Let's <br/><span className="text-blue-600 not-italic">Connect</span>
          </motion.h2>
          <motion.p variants={fadeInUp} className="text-lg md:text-xl text-gray-600 mb-10 md:mb-12 max-w-md font-medium leading-relaxed">
            Reach out today to secure your spot or book a tour of our Calgary dayhome.
          </motion.p>
          
          <motion.div variants={fadeInUp} className="space-y-6 md:space-y-8">
            {/* Phone Option */}
            <div className="flex items-center gap-4 md:gap-6 group">
              <div className="bg-white p-4 md:p-5 rounded-2xl md:rounded-3xl shadow-xl text-pink-500 group-hover:bg-pink-500 group-hover:text-white transition-all">
                <Phone size={28} />
              </div>
              <div>
                <p className="text-gray-400 font-black uppercase text-[10px] tracking-widest mb-1">Direct Line</p>
                <p className="text-xl md:text-2xl font-black text-gray-800">+1 403-797-1472</p>
              </div>
            </div>

            {/* Email Option */}
            <div className="flex items-center gap-4 md:gap-6 group">
              <div className="bg-white p-4 md:p-5 rounded-2xl md:rounded-3xl shadow-xl text-blue-500 group-hover:bg-blue-600 group-hover:text-white transition-all">
                <Mail size={28} />
              </div>
              <div className="min-w-0"> {/* text overflow se bachne ke liye */}
                <p className="text-gray-400 font-black uppercase text-[10px] tracking-widest mb-1">Email Us</p>
                <p className="text-lg md:text-2xl font-black text-gray-800 truncate">littleaurorakids12@gmail.com</p>
              </div>
            </div>
          </motion.div>
        </motion.div>

        {/* Form Container - Mobile par padding aur rounding adjust ki hai */}
        <motion.div 
          initial={{ y: 50, opacity: 0 }} 
          whileInView={{ y: 0, opacity: 1 }} 
          viewport={{ once: true }} 
          className="bg-white p-6 md:p-14 rounded-[40px] md:rounded-[70px] shadow-2xl border border-gray-100"
        >
          {submitted ? (
            <div className="text-center py-16 md:py-20">
              <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} className="bg-green-100 text-green-600 w-20 h-20 md:w-24 md:h-24 rounded-full flex items-center justify-center mx-auto mb-8">
                <CheckCircle size={48} />
              </motion.div>
              <h3 className="text-2xl md:text-3xl font-black text-gray-900 mb-4 tracking-tighter">Inquiry Sent!</h3>
              <button onClick={() => setSubmitted(false)} className="text-pink-500 font-black underline uppercase tracking-widest text-sm">Send again</button>
            </div>
          ) : (
            <form ref={form} className="space-y-5 md:space-y-6" onSubmit={sendEmail}>
              <div className="grid md:grid-cols-2 gap-5 md:gap-6">
                <div className="space-y-2">
                  <label className="text-[10px] font-black uppercase tracking-widest text-gray-500 ml-2">Parent Name</label>
                  <input type="text" name="from_name" required className="w-full bg-gray-50 border-2 border-gray-200 px-6 md:px-8 py-4 md:py-5 rounded-[20px] md:rounded-[30px] focus:border-blue-500 transition-all font-bold text-gray-800 outline-none" placeholder="Enter name" />
                </div>
                <div className="space-y-2">
                  <label className="text-[10px] font-black uppercase tracking-widest text-gray-500 ml-2">Phone Number</label>
                  <input type="tel" name="phone_number" required className="w-full bg-gray-50 border-2 border-gray-200 px-6 md:px-8 py-4 md:py-5 rounded-[20px] md:rounded-[30px] focus:border-blue-500 transition-all font-bold text-gray-800 outline-none" placeholder="(403) 000-0000" />
                </div>
              </div>
              <div className="space-y-2">
                <label className="text-[10px] font-black uppercase tracking-widest text-gray-500 ml-2">Email Address</label>
                <input type="email" name="reply_to" required className="w-full bg-gray-50 border-2 border-gray-200 px-6 md:px-8 py-4 md:py-5 rounded-[20px] md:rounded-[30px] focus:border-blue-500 transition-all font-bold text-gray-800 outline-none" placeholder="hello@example.com" />
              </div>
              <div className="space-y-2">
                <label className="text-[10px] font-black uppercase tracking-widest text-gray-500 ml-2">Message</label>
                <textarea name="message" rows="3" className="w-full bg-gray-50 border-2 border-gray-200 px-6 md:px-8 py-4 md:py-5 rounded-[20px] md:rounded-[30px] focus:border-blue-500 transition-all font-bold text-gray-800 outline-none resize-none" placeholder="Tell us about your needs..."></textarea>
              </div>
              <button 
                type="submit"
                disabled={loading}
                className={`w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white font-black py-5 md:py-6 rounded-[20px] md:rounded-[30px] shadow-2xl hover:scale-[1.02] active:scale-[0.98] transition-all flex items-center justify-center gap-3 text-base md:text-lg uppercase tracking-widest ${loading ? 'opacity-50' : ''}`}
              >
                {loading ? "Sending..." : "Send Message"} <Send size={20} />
              </button>
            </form>
          )}
        </motion.div>
      </div>
    </div>
  </div>
</section>
  );
};


export default function App() {
  // Structured Data for Google (Local Business SEO)
const businessSchema = {
    "@context": "https://schema.org",
    "@type": "Dayhome",
    "name": "Little Aurora Kids",
    "description": "Premium childcare and dayhome services in Calgary. Nurturing environment for infants, toddlers, and preschoolers.",
    // Main image updated to our new SEO name
    "image": "https://littleaurorakids.com/assets/daycare-calgary-indoor-play-area.jpeg", 
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "41 Corner Ridge Mews NE",
      "addressLocality": "Calgary",
      "addressRegion": "AB",
      "postalCode": "T3N 1X4",
      "addressCountry": "CA"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "51.1333",
      "longitude": "-113.9333"
    },
    "telephone": "+14037971472",
    "url": "https://littleaurorakids.com", // Domain updated
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "07:00",
        "closes": "18:00"
      }
    ]
  };

  return (
    <HelmetProvider>
      <div className="font-sans selection:bg-pink-200 selection:text-pink-900 overflow-x-hidden antialiased">
        
        {/* --- SEO HELMET START --- */}
        <Helmet>
          <title>Little Aurora Kids | Best Dayhome & Childcare in Calgary</title>
          <meta name="description" content="Looking for the best dayhome in Calgary? Little Aurora Kids offers premium, safe, and creative childcare for infants, toddlers, and preschoolers. Enroll your child today!" />
          <meta name="keywords" content="Dayhome Calgary, Childcare Calgary NE, Preschool Calgary, Infant care Calgary, Little Aurora Kids" />
          <link rel="canonical" href="https://littleaurorakids.com" />
          
          {/* Open Graph (Facebook/WhatsApp Preview) */}
          <meta property="og:title" content="Little Aurora Kids | Premium Calgary Dayhome" />
          <meta property="og:description" content="Where every child's growth is celebrated with love and creativity in Calgary." />
          {/* Image path updated with our SEO filename */}
          <meta property="og:image" content="https://littleaurorakids.com/assets/daycare-calgary-indoor-play-area.jpeg" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://littleaurorakids.com" />

          {/* Schema Markup */}
          <script type="application/ld+json">
            {JSON.stringify(businessSchema)}
          </script>
        </Helmet>
        {/* --- SEO HELMET END --- */}

        {/* Accessibility ke liye Hidden H1 jo Google dekhe ga */}
        <h1 className="sr-only">Little Aurora Kids Dayhome Calgary - Premium Childcare & Preschool Services</h1>
        
        <Navbar />

        {/* WhatsApp Floating Button with ARIA Label for SEO */}
        <motion.a
          href="https://wa.me/+14037971472"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Contact Little Aurora Kids on WhatsApp"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          className="fixed bottom-8 right-8 z-[100] bg-[#25D366] text-white p-4 rounded-full shadow-[0_10px_40px_rgba(37,211,102,0.4)] flex items-center justify-center group"
        >
          <span className="absolute right-full mr-4 bg-white text-gray-800 px-4 py-2 rounded-2xl text-xs font-black uppercase tracking-widest shadow-xl opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap border border-gray-100 pointer-events-none">
            Chat with us
          </span>
          <svg viewBox="0 0 24 24" width="32" height="32" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.067 2.877 1.218 3.075.149.198 2.095 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
          </svg>
        </motion.a>

        <main>
          <Hero />
          <About />
          <Programs />
          <Gallery />
          <VideoSection />
          <LocationSection />
          <Contact />
        </main>

        <footer className="py-20 bg-[#FDFCFB] border-t border-gray-100">
          <div className="container mx-auto px-6 flex flex-col items-center">
            <div className="flex items-center gap-3 mb-12">
              <div className="bg-pink-500 p-2 rounded-2xl shadow-lg">
                <RainbowIcon className="text-white w-6 h-6" />
              </div>
              <span className="text-3xl font-black text-gray-900 tracking-tighter italic">Little Aurora Kids</span>
            </div>
            <p className="text-gray-400 text-xs font-black uppercase tracking-[0.3em] mb-4 text-center">
              © 2024 Little Aurora Kids • Calgary, AB • Top Rated Dayhome Calgary
            </p>
          </div>
        </footer>

        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@600;700;800&display=swap');
          
          body {
            font-family: 'Plus Jakarta Sans', sans-serif;
            scroll-behavior: smooth;
          }

          .sr-only {
            position: absolute;
            width: 1px;
            height: 1px;
            padding: 0;
            margin: -1px;
            overflow: hidden;
            clip: rect(0, 0, 0, 0);
            white-space: nowrap;
            border-width: 0;
          }

          .shadow-3xl {
            box-shadow: 0 50px 100px -20px rgba(0, 0, 0, 0.05), 0 30px 60px -30px rgba(0, 0, 0, 0.05);
          }

          @keyframes gradient-x {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
          }
          .animate-gradient-x {
            background-size: 200% 200%;
            animation: gradient-x 10s ease infinite;
          }
        `}</style>
      </div>
    </HelmetProvider>
  );
}
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import HomePage from './pages/HomePage';
// import SignInPage from './pages/SigninPage';
// import SignupPage from './pages/SignupPage';
// import CostcoStoreView from './pages/CostcoStoreView';
// import AdminDashboard from './pages/AdminDashboard';
// function App() {
//   return (
//     <AdminDashboard></AdminDashboard>
//   );
// }

// export default App;